import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";

const moduleName = "inOutReport"; //收支报表

store.registerModule(moduleName, {
  namespaced: true,
  state: {},
  actions: {
    // 支出报表堆积图
    async outComeExpenditure(a, payload) {
      let result = await api.get(
        `/api/IncomeAndExpenditureReport/Expenditure?BaseId=${
          payload.baseId
        }&Batch=${payload.batch}&PondId=${payload.pondId}&StartDate=${
          payload.startDate
        }&EndDate=${payload.endDate}`
      );
      return result;
    },
    // 收入堆积图
    async inOutReportData(a, payload) {
      let result = await api.get(
        `/api/IncomeAndExpenditureReport/Income?BaseId=${
          payload.baseId
        }&Batch=${payload.batch}&PondId=${payload.pondId}&StartDate=${
          payload.startDate
        }&EndDate=${payload.endDate}`
      );
      return result;
    },
    // 对比分析图
    async compareLineData(a, payload) {
      let result = await api.get(
        `/api/IncomeAndExpenditureReport/Compared?BaseId=${
          payload.baseId
        }&Batch=${payload.batch}&PondId=${payload.pondId}&StartDate=${
          payload.startDate
        }&EndDate=${payload.endDate}`
      );
      return result;
    }
  },
  mutations: {},
  getters: {}
});

export default moduleName;
